<div data-testid="vendor-manage-sku-page" class="p-6 flex-table-page">
  <!-- Header with Back Button -->
  <div class="page-header mb-6 flex items-center justify-between flex-table-header">
    <div>
      <h2 class="page-title">
        {{ "vendor.manage_sku.title" | translate }}
      </h2>
    </div>
    <div class="flex gap-3">
      <app-button
        [testId]="'vendor-manage-sku-back-btn'"
        [label]="'common.actions.back' | translate"
        (emitOnClick)="onBack()"
        [outlined]="true"
        type="secondary"
      ></app-button>
    </div>
  </div>

  <!-- Vendor Info -->
  <div class="mb-6 flex-table-header" *ngIf="vendorCode() || vendorName()">
    <p class="text-sm text-gray-600">
      <span class="font-medium"
        >{{ "vendor.table.columns.vendor" | translate }}:</span
      >
      {{ vendorCode() }} – {{ vendorName() }}
    </p>
  </div>

  <!-- Search Form -->
  <app-search-form
    data-testid="vendor-manage-sku-search-form"
    [searchFormat]="searchFormat()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      @if (canUpdate()) {
        <app-button
          [testId]="'vendor-manage-sku-add-btn'"
          type="info"
          icon="add"
          (emitOnClick)="onOpenAddSkuDialog()"
          [label]="'common.actions.new' | translate"
        ></app-button>
      }
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="vendor-manage-sku-table"
      [dataSource]="vendorSkus()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="[]"
      [loading]="loading()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [totalRecords]="totalRecords()"
      scrollHeight="flex"
      [showInternalColumnConfigButton]="false"
      class="w-full"
      (pageChange)="onPageChange($event)"
    >
    <!-- Custom Template for Status Column -->
    <ng-template
      #customTemplate
      let-value
      let-column="column"
      let-rowData="rowData"
    >
      @if (column?.prop === "active") {
        <div class="flex items-center justify-center gap-1 w-full">
          <p-tag
            data-testid="vendor-manage-sku-status-tag"
            [value]="
              value
                ? ('vendor.status.active' | translate)
                : ('vendor.status.inactive' | translate)
            "
            [severity]="value ? 'success' : 'secondary'"
            styleClass="status-tag"
            [pTooltip]="
              value
                ? ('vendor.status.active' | translate)
                : ('vendor.status.inactive' | translate)
            "
            tooltipPosition="top"
            tooltipStyleClass="custom-tooltip"
            [showDelay]="300"
            [hideDelay]="0"
          />
        </div>
      } @else if (column?.prop === "primaryFlag") {
        <div class="flex items-center justify-center gap-1 w-full">
          @if (value) {
            <p-tag
              data-testid="vendor-manage-sku-primary-tag"
              [value]="'vendor.manage_sku.primary_yes' | translate"
              severity="info"
              styleClass="status-tag"
            />
          } @else {
            <span class="text-slate-400">—</span>
          }
        </div>
      }
    </ng-template>

    <!-- Actions Template -->
    <ng-template #actionsTemplate let-record>
      <div class="inline-flex items-center gap-2 whitespace-nowrap">
        @if (canUpdate()) {
          <span
            [attr.data-testid]="'vendor-manage-sku-action-edit-' + record.id"
            (click)="onOpenEditSkuDialog(record)"
            class="action-link action-edit cursor-pointer"
          >
            {{ "common.actions.edit" | translate }}
          </span>
          <span
            [attr.data-testid]="'vendor-manage-sku-action-toggle-status-' + record.id"
            (click)="onToggleActiveStatus(record)"
            class="action-link cursor-pointer"
            [class.action-enable]="!record.active"
            [class.action-disable]="record.active"
          >
            {{
              record.active
                ? ("vendor.actions.deactivate" | translate)
                : ("vendor.actions.activate" | translate)
            }}
          </span>
        }
        @if (canDelete()) {
          <span
            [attr.data-testid]="'vendor-manage-sku-action-delete-' + record.id"
            (click)="onDeleteSku(record)"
            class="action-link action-delete cursor-pointer"
          >
            {{ "common.actions.delete" | translate }}
          </span>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="vendor-manage-sku-toast"></p-toast>

<!-- Vendor SKU Dialog (Add/Edit) -->
<app-vendor-sku-dialog
  data-testid="vendor-manage-sku-dialog"
  [visible]="showSkuDialog()"
  [editMode]="editMode()"
  [initialData]="getDialogInitialData()"
  [loading]="dialogLoading()"
  (visibleChange)="showSkuDialog.set($event)"
  (confirm)="onDialogConfirm($event)"
  (cancel)="onDialogCancel()"
></app-vendor-sku-dialog>

<!-- Delete Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'vendor-manage-sku-delete-dialog'"
  [visible]="showDeleteDialog()"
  [title]="'vendor.manage_sku.delete.title'"
  [message]="'vendor.manage_sku.delete.message'"
  [buttons]="[
    { label: 'common.actions.cancel', action: 'cancel', outlined: true },
    {
      label: 'common.actions.delete',
      action: 'confirm',
      severity: 'danger',
      loading: deleteLoading(),
    },
  ]"
  (emitOnClick)="onDeleteDialogonClick($event)"
  (visibleChange)="showDeleteDialog.set($event)"
></app-confirmation-dialog>

<!-- Toggle Status Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'vendor-manage-sku-toggle-status-dialog'"
  [visible]="showToggleStatusDialog()"
  [title]="toggleStatusTitle()"
  [message]="toggleStatusMessage()"
  [buttons]="toggleStatusButtons()"
  (emitOnClick)="onToggleStatusDialogAction($event)"
  (visibleChange)="showToggleStatusDialog.set($event)"
></app-confirmation-dialog>
